// Setzt `data-tutorial` nur auf dem ersten Element einer Liste, damit die Tour
// in `.map()`-Schleifen genau einen eindeutigen Anker findet statt einem pro Zeile.
// `register-check` erkennt den Aufruf `anker('…')` als gesetzten Anker.
export const anker = (name: string, aktiv: boolean = true) => ({ 'data-tutorial': aktiv ? name : undefined } as const);
